<template>
    <div>
        <div class="panel-tag mt-3" v-if="!isLoading && Object.keys(orderItems).length == 0">
            {{ $t('table.no_records') }}
        </div>
        <div v-if="!isLoading && Object.keys(orderItems).length != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <div class="row">
                        <div v-for="(item, k) in orderItems" :key="'expenses_card_' + k" class="col-12 col-lg-6 mb-3">
                            <b-card>
                                <div class="badge badge-primary mb-2" style="font-size: 20px">{{ item['category'] }}</div>
                                <div class="row">
                                    <div class="col-6 h3 text-muted">
                                        Spent
                                        <div class="h1 text-info">
                                            {{ formatMoney(item['expenditures']) }}
                                            <span v-if="item['expenditures']">
                                                <span :class="item['expenditures'] > item['projection'] ? 'text-danger' : 'text-success'">
                                                ({{ getSpentPercent(item) }}%)
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div v-show="item['card_projection']" class="col-6 h3 text-muted">
                                        Projection
                                        <div class="h1 text-primary">
                                        {{ formatMoney(item['projection']) }}
                                        </div>
                                    </div>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import tbl from './../../../../assets/js/dashboard/table-header'
import exp from './../../../../assets/js/dashboard/export-table-header'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { getOutletName, handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { formatPrice } from './../../../../assets/js/dashboard/utilities'


export default {
    name: 'expensesCard',
    props: {
        expenditureType: {
            type: Array,
            default(rawProps) {
                return []
            },
        },
    },
    components: {
    },
    data() {
        return {
            tblHeaders: tbl.orderTblHdr,
            orderItems: {},
            outlet: [],
            isLoading: false,
            mobile: "",
            filterObj: {},

            modalShow: false,
        }
    },
    computed: {
        fields() {
            var fArr = []
            if (this.filterObj.itemType != 'all') {
                fArr.push({ key: "index", label: '#', thClass: 'thead-themed align-middle' })
            }
            var arr = [
                { key: "createDate", label: 'Date & Time' },
                { key: "name", label: 'Name' },
                { key: "amount", label: 'Amount' },
                { key: "expenditureType", label: 'Category' },
                { key: "invoice", label: 'Invoice / Receipt' },
                { key: "remarks", label: 'Remark' },
                { key: "action", label: 'Action' },
            ]
            fArr.push(...arr)
            return fArr
        },
        exportFields() {
            var ret = {}
            ret["#"] = "index"
            ret['Category'] = "category"
            ret['Expenditures'] = "expenditures"
            ret['Projection'] = "projection"
            return ret
        },
    },
    watch: {
        "$i18n.locale"(val) {
            this.setExportData(this.orderItems, this.filterObj)
        }
    },
    methods: {
        formatMoney(value) {
            return formatPrice(value)
        },
        getSpentPercent(item) {
            if(item['expenditures'] && item['projection']) {
                return formatPrice(Math.ceil(item['expenditures'] / item['projection'] * 100))
            }

            return '-'
        },

        setData(items, filterObj) {
            this.isLoading = false

            let temp = {}
            for(let item of items) {
                temp[item['category'].toLowerCase()] = item
            }

            let totalExpenses = {
                category: 'Total',
                projection : 0,
                expenditures: 0,
                card_projection: true,
            }
            this.orderItems = []
            for(let categoryItem of this.expenditureType) {
                let category = categoryItem['text'].toLowerCase()
                if(temp[category]) {
                    temp[category]['card_projection'] = categoryItem['card_projection']
                    this.orderItems.push(temp[category])

                    totalExpenses['projection'] += temp[category]['projection']
                    totalExpenses['expenditures'] += temp[category]['expenditures']
                }
            }

            console.log(this.orderItems)
            console.log(totalExpenses)
            this.orderItems.push(totalExpenses)

            this.filterObj = filterObj
            this.setExportData(this.orderItems, filterObj)
        },
        setExportData(group, filterObj) {
            var exportData = []
            for (var k = 0; k < group.length; k++) {
                var obj = {
                    index: k + 1,
                    category: group[k]['category'],
                    expenditures: formatPrice(group[k]['expenditures']),
                    projection: formatPrice(group[k]['projection']),
                }

                exportData.push(obj)
            }

            var strDate = moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_expenses`)
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_expenses`),
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet.id == "all" ? this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) : filterObj.outlet.text),
                " "];
            var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName,
                exportFields: this.exportFields
            }

            this.$emit('setExportData', data)
        },

        generateReceipt(salesID) {
            const QUERY_STRING = "/" + salesID + this.$api.RECEIPT
            const url = this.$api.REPORT_SALES + QUERY_STRING;

            let $vm = this
            this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: this.$util.getSessionToken() }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        var path = response.data.path;
                        window.open(path, '_blank');
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
    },
    mounted() {
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
    }
}
</script>
<style scoped>
.show {
    display: block;
}
</style>
<style>
.nav-link,
.link {
    cursor: pointer;
}

.link>i {
    font-size: large;
}

.modal-body {
    max-height: 65vh;
    overflow-y: auto;
}

.modal-lg {
    max-width: 1000px;
}

.width-12 {
    width: 12%;
}
</style>